<script>
  import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Input, InputGroup } from '@sveltestrap/sveltestrap';

  import { classnames } from '@client/utils/classnames';

  let className = '';
  export { className as class };

  /** @type {'number' | undefined} */
  export let inputSize = undefined;

  /** @type {'sm' | 'lg' | undefined} */
  export let size;

  /** @type {InputType} */
  export let type = 'text';

  /** @type {string} */
  export let unit;

  /** @type {string[]} */
  export let units = [];

  /** @type {number | string} */
  export let value;

  $: classes = classnames('flex-nowrap', className);
</script>

<Dropdown autoClose>
  <InputGroup class={classes}>
    <slot />
    <Input {type} bsSize={size} size={inputSize} {...$$restProps} bind:value />
    <DropdownToggle outline {size}>{unit}</DropdownToggle>
  </InputGroup>
  <DropdownMenu>
    {#each units as name}
      <DropdownItem active={unit === name} on:click={() => (unit = name)} class="py-2">{name}</DropdownItem>
    {/each}
  </DropdownMenu>
</Dropdown>
